export const transformGridParams = (grid) => {
    if (grid?.resolutions) {
        return {
            resolutions: grid.resolutions,
            origin: [grid.originX, grid.originY],
            tileSize: grid.tileSize ?? undefined,
            extent: grid?.extent,
        };
    }
    else {
        return {
            extent: grid?.extent,
            tileSize: grid.tileSize ?? undefined,
        };
    }
};
//# sourceMappingURL=transformGridParams.js.map